/** Shared layout for slot list columns (slot assets + schedule). */

export const flowSlotListColumnScrollbarSx = {
  '&::-webkit-scrollbar': { width: '8px' },
  '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '4px' },
};

export const slotListScrollAreaSx = {
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  // Inset so selection outline (2px) and row chrome are not clipped by the scrollport.
  px: 1,
  pt: 0.5,
  pb: 1,
  boxSizing: 'border-box',
  ...flowSlotListColumnScrollbarSx,
};

/** Outer column: flex shell only — padding lives on the header block + scroll area. */
export const slotListColumnOuterSx = {
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  gap: 1,
};

/** Horizontal inset for content above the scroll area (e.g. alert, event-slot timing). */
export const slotListColumnHeaderInsetSx = {
  px: 1,
  flexShrink: 0,
};
